( function( $ ) {
    var IdrogenoSearchFormClass = {};
    IdrogenoSearchFormClass.run = function(formInstance){
        // private variables
        var thisSearchForm = $(formInstance);
        if (!$(thisSearchForm).hasClass("ssnail-search-form")) {
            thisSearchForm = $(formInstance).closest(".ssnail-search-form");
        }

        // private methods
        var submit = function() {
            var currentURL = window.IDROGENO_BASE_URL;
            var pathName = location.pathname;
            var newParams = [];
            var newQuery = [];
            var searchType = 'generic';

            var c = null;

            c = thisSearchForm.find('[name=s]').first();
            if (c.length === 1 && searchType === 'generic') {
                newQuery.push("s=" + encodeURIComponent(c.val()));
            }
            if (newParams.length > 0) {
                currentURL += newParams.join("/") + "/";
            }
            if (newQuery.length > 0) {
                currentURL += "?" + newQuery.join("&");
            }

            window.location = currentURL;
        };
        
        // public API
        return {
            submit: submit,
        };
    };

    
    $("form.ssnail-search-form").on("submit", function(event){
        event.preventDefault();
        event.stopPropagation();

        var ssnailSearchForm = new IdrogenoSearchFormClass.run($(this));
        ssnailSearchForm.submit();
    });
} )( jQuery );
